import { IPurchaseTransaction } from '@/services/types/TransactionData';

export const isAttachmentRequired = (purchaseTransactionData: IPurchaseTransaction) =>
  purchaseTransactionData.isReceiptRequired &&
  !purchaseTransactionData.hasAttachments &&
  purchaseTransactionData.receiptExemptionReason == null;
